import { chatDebugStore } from './chat-debug.store';

export function useSectionExpansion(
  sectionKey: string,
  defaultExpanded = false
): {
  isExpanded: boolean;
  toggle: () => void;
} {
  const session = chatDebugStore.active;
  const isExpanded =
    session?.isSectionExpanded(sectionKey, defaultExpanded) ?? defaultExpanded;
  const toggle = () => {
    session?.setSectionExpanded(sectionKey, !isExpanded);
  };
  return { isExpanded, toggle };
}
